import styled from "styled-components";
import { Flex } from "discover.medical.react-component-library";

export const Container = styled(Flex)`
  padding: ${({ theme }) => theme.space.lg};
  height: 100%;
  max-width: 38rem;
  width: 100%;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space.md};
`;

export const Checkmark = styled.img`
  width: 2.5rem;
  height: 2.5rem;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 4rem;
    height: 4rem;
  }
`;
